import { render, staticRenderFns } from "./SplitGuestTable.vue?vue&type=template&id=f51e20b6&scoped=true&"
import script from "./SplitGuestTable.vue?vue&type=script&lang=js&"
export * from "./SplitGuestTable.vue?vue&type=script&lang=js&"
import style0 from "./SplitGuestTable.vue?vue&type=style&index=0&id=f51e20b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f51e20b6",
  null
  
)

export default component.exports